import { render, staticRenderFns } from "./search_teacher.vue?vue&type=template&id=44b5e87a&scoped=true"
import script from "./search_teacher.vue?vue&type=script&lang=js"
export * from "./search_teacher.vue?vue&type=script&lang=js"
import style0 from "./search_teacher.css?vue&type=style&index=0&id=44b5e87a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5e87a",
  null
  
)

export default component.exports